import { all, Div, H3, Range, reactive, Span, VArray } from 'alkali'
import Dropdown from 'components/generic/Dropdown'
import * as positiveDirectionalityIcon from 'icons/monitor-heart-rate-up.svg'
import * as negativeDirectionalityIcon from 'icons/monitor-heart-rate-down.svg'
import { patch } from 'tools/request'
import Icon from 'components/Icon'
import './DirectionalityDropdown.css'

export class DirectionalityDropdown extends Dropdown.with('.directionality-dropdown') {
	ready({ outcomes }) {
		this.items = outcomes.map(outcome => ({
			content: [
				Div('.directionality-selector', {
					classes: {
						'selected-directionality': !outcome.isPositive,
					},
					onclick: () => {
						this.updateOutcome(outcome, false)
					}
				}, [
					Icon({
						icon: negativeDirectionalityIcon,
						title: 'Reducing ' + outcome.label + ' is the desired outcome',
					}),
				]),
				outcome.label,
				Div('.directionality-selector', {
					classes: {
						'selected-directionality': outcome.isPositive,
					},
					onclick: () => {
						this.updateOutcome(outcome, true)
					}
				}, [
					Icon({
						icon: positiveDirectionalityIcon,
						title: 'Increasing ' + outcome.label + ' is the desired outcome',
					})
				])
			],
		}))
	}
	outcomes: string
	analysisDirectionality: {}
	updateOutcome(outcome, isPositive) {
		if (confirm('Are you sure you want to update ' + (outcome || this.outcome).label + ' to be ' + (isPositive ? 'positive' : 'negative') + '?')) {
			if (this.analysisDirectionality) {
				this.analysisDirectionality.put(isPositive)
			} else {
				patch(`/portal/PhraseDirectionality/` + encodeURI(outcome.id || this.outcome.id), {
					data: { isPositive }
				}).then(() => {
					//alert('Updated, refresh to see changes')
					if (this.onChange)
						this.onChange(isPositive)
					//else
//						location.reload()
				}, (error) => alert(error.message))
			}
		}
	}
}